export const PRIMARY_ADMIN_EMAIL = 'ezradixon29@gmail.com';

export const normalizeEmail = (value) => {
  if (typeof value !== 'string') return '';
  return value.trim().toLowerCase();
};

export const isAdminEmail = (email, adminEmails = []) => {
  const normalized = normalizeEmail(email);
  if (!normalized) return false;
  const list = new Set([
    normalizeEmail(PRIMARY_ADMIN_EMAIL),
    ...adminEmails.map(normalizeEmail).filter(Boolean),
  ]);
  return list.has(normalized);
};